import { Route } from '@/routes/estimation-versions/$projectId/index';

import EstimationVersionsContainer from './EstimationVersionsContainer';

const EstimationVersionsPage = () => {
  const { projectId } = Route.useLoaderData();

  return (
    <div className='main-container-right-header'>
      <EstimationVersionsContainer projectId={projectId} />
    </div>
  );
};

export default EstimationVersionsPage;
